import { ValidationType } from './model/Enums'

export const COOKIE_NAMES = ['extcsasid', '_ga', '_gid', '_fbp', 'aam_exponea', 'aam_uuid']

export const FILENAME_LENGTH = 50

export const SPECIAL_VALIDATION_FIELDS = [
  ValidationType.PhoneEnha,
  ValidationType.Phone,
  ValidationType.AccountNumber,
  ValidationType.Date,
  ValidationType.Number,
  ValidationType.ZipCode,
  ValidationType.PersonalId
]

export const SOURCE_VALUE = 'url'
export const SOURCE_NAME = 'Zdroj leadu'

export const DATE_FORMAT = 'd. M. yyyy'
export const DATE_DATA_FORMAT = 'd.M.yyyy'
export const TEXT_AREA_MAX_LENGTH = 2000
export const LANGUAGE_HEADER = {
  cs: 'cs-CZ',
  en: 'en-EN'
}

export const VALID_DIALLING_CODES = ['+420', '+421']
